import React from "react";
import { Outlet } from "react-router-dom";

const Main = () => {
  return (
    <div className="bg-site bg-no-repeat bg-cover overflow-hidden">
      <Outlet />
    </div>
  );
};

export default Main;
